import React from 'react';
import { Offcanvas } from 'react-bootstrap';
import { OffCanvasFilters } from './OffCanvasFilters';
import { ColumnDefinition } from 'features/gridReport/models';

interface OffCanvasSidebarProps {
  show: boolean;
  handleClose: () => void;
  offCanvasFilters: ColumnDefinition[];
  columns: ColumnDefinition[];
  onSaveColumnSelection?: (selectedFields: string[]) => void;
  renderFilterComponent: (item: ColumnDefinition) => React.ReactNode;
}

export const OffCanvasSidebar: React.FC<OffCanvasSidebarProps> = ({
  show,
  handleClose,
  offCanvasFilters,
  columns,
  onSaveColumnSelection,
  renderFilterComponent,
}) => (
  <Offcanvas show={show} onHide={handleClose} placement={'end'}>
    <Offcanvas.Header closeButton>
      <Offcanvas.Title>More Filters</Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body>
      <OffCanvasFilters
        offCanvasFilters={offCanvasFilters}
        renderFilterComponent={renderFilterComponent}
      />
    </Offcanvas.Body>
  </Offcanvas>
);
